<template>
  <div class="basicInformation">
    <div class="re-bigbox">
      <div class="flex-x-center">
        <div class="con-register">
          <div class="two-menu">
            <el-menu
              active-text-color="#f56c6c"
              :default-active="activeIndexTwo"
              class="el-menu-demo"
              mode="horizontal"
            >
              <el-menu-item
                @click="routeHop('/home')"
                index="1"
                class="basics-b"
              >
                基本资料</el-menu-item
              >
              <el-menu-item
                @click="routeHop('/accountSecurity')"
                index="2"
                class="basics-b"
              >
                账户安全</el-menu-item
              >
            </el-menu>
          </div>

          <!-- 修改密码 -->
          <account></account>

          <!-- 密保手机 -->
          <mobile></mobile>

          <!-- 备份密保手机 -->
          <mobile2></mobile2>

          <!-- 人像验证 -->
          <!-- <certification></certification> -->

          <!-- 学历认证 -->
          <education></education>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";

import account from "@/pages/user/items/account.vue";
import mobile from "@/pages/user/items/mobile.vue";
import mobile2 from "@/pages/user/items/mobile2.vue";
import certification from "@/pages/user/items/certification.vue";
import education from "@/pages/user/items/education.vue";
export default {
  components: {
    account,
    mobile,
    mobile2,
    certification,
    education,
  },
  data() {
    return {
      activeIndexTwo: "2",
    };
  },
  methods: {
    ...mapActions(useMainStore, {
      token: "updateToken",
      changeProject: "updateProjectDetail",
      changUser: "updateUserInfo",
      changUserCert: "updateUserCertInfo",
    }),
    //退出登录
    loginOut() {
      let that = this;
      that.token("");
      that.changUser({});
      that.changUserCert({});
      that.changeProject([]);
      that.$router.push("/login");
    },

    routeHop(url) {
      this.$router.push(url);
    },
  },
  computed: {
    ...mapState(useMainStore, {
      userInfo: "getUserInfo",
    }),
  },
  mounted() {
    console.log(this.userInfo, "store");
  },
};
</script>

<style scoped>
.basics-b {
  font-size: 16px;
  color: black;
}
</style>
